module.exports = __webpack_public_path__ + "static/hardware4-1dbcc120ebb72d84bd30c6159d6aba50.jpg";